import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdjustmentComponent } from './adjustment.component';


const routes: Routes = [
  {
    path: '',
    component: AdjustmentComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ScenarioAdjustmentRoutingModule { }
